module.exports = "pegasus_template/assets/theme5/google-icon.png";